import { LayerTypeSelectionHeaderProps } from "../../types";
import { useUtilityById } from "./useUtilityById";

export function UtilitySelectionHeader({ selection }: Readonly<LayerTypeSelectionHeaderProps>) {
  const selectedUtility = useUtilityById(selection.id);

  if (!selectedUtility) return null;

  return (
    <div className="flex flex-row items-start gap-x-2">
      <div
        className="w-4 h-4 rounded-sm shrink-0"
        style={{
          backgroundColor: selectedUtility.properties.fill ?? selectedUtility.properties.stroke,
        }}
      />
      <div className="flex flex-col items-stretch grow">
        <div className="text-xs font-semibold text-text-base-tertiary">{selectedUtility.properties.Category}</div>
        <div className="text-sm font-semibold text-text-base-primary line-clamp-3">
          {selectedUtility.properties.Provider}
        </div>
      </div>
    </div>
  );
}
